import BenchmarkScoreService from 'src/modules/benchmarkScore/benchmarkScoreService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';
import CompanyService from 'src/modules/company/companyService';

const prefix = 'BENCHMARKSCORE_FORM';

const benchmarkScoreFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id, company?) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkScoreFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await BenchmarkScoreService.find(id);
      } else if (company) {
        record['company'] = await CompanyService.find(company);
      }

      dispatch({
        type: benchmarkScoreFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkScoreFormActions.INIT_ERROR,
      });

      getHistory().push('/benchmark-score');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkScoreFormActions.CREATE_STARTED,
      });

      await BenchmarkScoreService.create(values);

      dispatch({
        type: benchmarkScoreFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.benchmarkScore.create.success'),
      );

      getHistory().push('/benchmark-score');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkScoreFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: benchmarkScoreFormActions.UPDATE_STARTED,
      });

      await BenchmarkScoreService.update(id, values);

      dispatch({
        type: benchmarkScoreFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.benchmarkScore.update.success'),
      );

      getHistory().push('/benchmark-score');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkScoreFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default benchmarkScoreFormActions;
